import React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { getSafe } from '../../../helpers/global';
import { openReplyDialog, openCADetailDialog } from '../../../actions/app';
import { CA_MODE } from '../../../constants/app';

class CACellRender extends React.Component {
  render() {
    const { } = this.props;
    return (
      <div className="custom-ca-cell">
        {this.renderContent()}
      </div>
    )
  }

  handleReply(data) {
    openCADetailDialog(data, CA_MODE.REPLY_MODE);
  }

  handleAmend(data) {
    openCADetailDialog(data, CA_MODE.AMEND_MODE);
  }

  handleCancel(data) {
    openCADetailDialog(data, CA_MODE.CANCEL_MODE);
  }

  handleViewDetail(data) {
    openCADetailDialog(data, CA_MODE.DETAIL_MODE);
  }

  renderAction(data) {
    const { language } = this.props;
    let actions = [];
    if (data.eventType && data.eventType !== 'XO') {
      switch (data.command) {
        case 'A': actions = [{ id: 1, text: 'common_reply', className: 'ca-action-item clickable', handleAction: () => this.handleReply(data) }]
          break;
        case 'B': actions = [
          { id: 1, text: 'common_amend', className: 'ca-action-item clickable', handleAction: () => this.handleAmend(data) },
          { id: 2, text: 'common_cancel', className: 'ca-action-item clickable', handleAction: () => this.handleCancel(data) }
        ]
          break;
        case 'C': actions = [{ id: 1, text: 'common_closed', className: 'ca-action-item', handleAction: () => { } }]
          break;
        default: break;
      }
    } else if (data.eventType === 'XO') {
      switch (data.command) {
        case 'C': actions = [{ id: 1, text: 'common_closed', className: 'ca-action-item', handleAction: () => { } }]
          break;
        default: break;
      }
    }
    return (
      <div className='ca-action'>
        {actions.map(act =>
          <span key={act.id} className={classnames(act.className)} onClick={act.handleAction}>{language[act.text]}</span>
        )}
      </div>
    )
  }

  renderText(prefix, postfix) {
    const { language } = this.props;
    const language_key = `${prefix}_${postfix}`
    let text = getSafe(() => language[language_key], postfix);
    return <div><span>{text}</span></div>
  }

  renderDetail() {
    const { language, data } = this.props;
    return <div className='text-center'><span className='clickable' onClick={() => this.handleViewDetail(data)}>{language.common_details}</span></div>
  }

  renderContent() {
    const { colDef, data } = this.props;
    switch (colDef.colId) {
      case 'common_actions': return this.renderAction(data);
      case 'common_details': return this.renderDetail(data);
      case 'common_event': return this.renderText('ca_event', data.eventType);
      case 'common_status': return this.renderText('ca_status', data.eventStatus);
      default: break;
    }
  }
}

export default connect(
  state => ({
    language: state.app.language
  })
)(CACellRender)
